import createReducer from '../../../../../../../helpers/createReducer';
import { updateLowStockItemsSearchQuery } from '../../../../../actions/reports/low-stock-items';

const initialState = {
  inventoryLocationId: []
};

const updateLowStockItemsSearchQueryHandler = action => ({
  [action.toString()]: (_, { payload: searchQuery }) => searchQuery
});

export default createReducer(initialState, {
  ...updateLowStockItemsSearchQueryHandler(updateLowStockItemsSearchQuery)
});
